import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { onServerWaking } from '../services/retry';
import './ServerWakeBanner.css';

// Shown at the top of every page while we wait for the sleeping backend to wake up.
function ServerWakeBanner() {
  const [waking, setWaking] = useState(false);

  useEffect(() => onServerWaking(setWaking), []);

  if (!waking) return null;

  return (
    <div className="wake-banner" role="status">
      <Spinner animation="border" size="sm" />
      <span>Waking up our deals server, this can take up to a minute. Thanks for waiting!</span>
    </div>
  );
}

export default ServerWakeBanner;
